export default {
  "foot": {
    "title": "Gracze Century Games",
    "p1": "Wpisz swoje ID użytkownika i zapłać za doładowanie. Kwota zostanie zaktualizowana bezpośrednio na Twoim powiązanym koncie. Jeśli się nie pojawi, załaduj grę ponownie lub w razie potrzeby skontaktuj się z obsługą klienta.",
    "p2": "Jeśli masz jakiekolwiek pytania, skontaktuj się z obsługą klienta. Dziękujemy za Twoje wsparcie!",
    "copyright": "© Copyright 2024 Century Games.",
    "service": "Warunki usługi",
    "policy": "Polityka prywatności",
    "descriptionTitle": "Jak to działa?"
  },
  "accept": {
    "title": "Ta strona korzysta z plików cookie, aby zapewnić lepszą jakość przeglądania. Przeczytaj naszą <a href=\"https://www.centurygames.com/privacy-policy/\" style=\"color: #58a8a5;\">Politykę prywatności</a>, aby uzyskać informacje o tym, co gromadzimy w naszej witrynie. Kontynuując korzystanie z tej witryny, wyrażasz zgodę na przechowywanie plików cookie na Twoim urządzeniu i uzyskiwanie do nich dostępu.",
    "decline": "Odrzuć",
    "accept": "Akceptuj"
  },
  "game": {
    "inapptext": "Lub zaloguj się poprzez grę",
    "loginfail": "Logowanie nie powiodło się",
    "logintip": "Jeśli autoryzacja gry nie powiodła się, zaktualizuj grę do najnowszej wersji lub wypróbuj inną przeglądarkę.",
    "reloadmsg": "Aby uzyskać wynik logowania, naciśnij przycisk „Załaduj ponownie”.",
    "reload": "Załaduj ponownie",
    "appnotice": "Jeśli chcesz zalogować się poprzez aplikację gry, użyj zewnętrznej przeglądarki, aby otworzyć sklep.",
    "changeaccount": "Czy na pewno chcesz się wylogować ze swojego konta?",
    "login": "Zaloguj",
    "notice": "Ogłoszenie",
    "confirm": "Potwierdź",
    "loginuserid": "ID Użytkownika",
    "palceholder": "Wprowadź ID Użytkownika",
    "okbtn": "OK",
    "loginbtn": "Zaloguj się przez grę",
    "changebtn": "Lub zaloguj się przez ID Użytkownika",
    "useTitle": "KONTO",
    "checkBtn": "Sprawdź",
    "findid": "Nie możesz znaleźć swojego ID Użytkownika?",
    "checktext": "Zwykle znajduje się w ustawieniach. Kliknij znak zapytania, aby uzyskać więcej wskazówek.",
    "username": "Nazwa:",
    "userId": "ID Użytkownika:",
    "packageTitle": "KWOTA DOŁADOWANIA",
    "edit": "Edytuj",
    "paymentTitle": "METODA PŁATNOŚCI",
    "total": "W sumie",
    "goPay": "Zapłać teraz",
    "noSelectPackageTips": "Nie wybrano kwoty",
    "payFail": "PŁATNOŚĆ NIEUDANA",
    "camelPayfail": "Płatność nieudana",
    "payFailTips1": "Skontaktuj się z obsługą klienta Adyen",
    "payFailTips2": "Skontaktuj się z obsługą klienta PayPal",
    "paySuccess": "PŁATNOŚĆ UDANA",
    "paySuccessTips2": "Najpierw załaduj grę ponownie, zanim skontaktujesz się z Obsługą Klienta w sprawie nieotrzymania zakupu!",
    "camelPaySuccess": "Płatność udana",
    "transactionId": "ID Transakcji",
    "paySuccessTips": "Dostawa przedmiotu może chwilę potrwać, proszę czekać",
    "deliveryFail": "DOSTARCZENIE NIE POWIODŁO SIĘ",
    "deliveryFailTips": "Skontaktuj się z Obsługą Klienta",
    "orderTitle": "Podsumowanie zamówienia",
    "paidWith": "Metoda płatności",
    "orderID": "ID Transakcji",
    "payStatus": "Status płatności",
    "orderTotal": "Cena całkowita",
    "transactionDate": "Data transakcji",
    "goOnPay": "Kup ponownie",
    "getInvoice": "Faktura",
    "camelDeliveryFail": "Dostarczenie nie powiodło się",
    "confirmOrder": "POTWIERDZENIE ZAMÓWIENIA",
    "confirmFollow": "Prosimy potwierdzić poniższe:",
    "nickname": "Nazwa",
    "packageName": "Przedmioty",
    "totalPayment": "Cena całkowita",
    "confirmPayWith": "Metoda płatności",
    "confirmAndGoOn": "Potwierdź i kontynuuj płatność",
    "orderCancel": "Anuluj",
    "getInvoiceTitle": "WYŚLIJ POPRZEZ E-MAIL",
    "getInvoiceTips": "Jeśli chcesz otrzymać fakturę e-mailem, prosimy o podanie adresu e-mail.",
    "getInvoiceTips1": "Podaj swój adres e-mail, aby otrzymać fakturę",
    "getInvoiceTips2": "Wyraź zgodę na gromadzenie i przechowywanie Twojego adresu e-mail.",
    "getInvoiceTips3": "Wyraź zgodę na otrzymywanie e-maili o zniżkach, promocjach i nie tylko dotyczących naszych gier za pośrednictwem poczty elektronicznej.",
    "invoiceSend": "Wyślij",
    "sendSuccess": "Wysłano fakturę na e-maila",
    "id404": "Nie znaleziono ID Użytkownika",
    "packageLoadingText": "Aktualizowanie przedmiotów w sklepie...",
    "taxTips": "Cena zawiera podatki",
    "adyenTips": "Usługę płatniczą świadczy firma Adyen, która działa na podstawie licencji bankowej i jest nadzorowana przez Holenderski Bank Centralny. Jeśli masz jakiekolwiek pytania dotyczące certyfikatów, odwiedź stronę <a href=\"https://www.adyen.com/platform/certifications\">https://www.adyen.com/platform/certifications</a>. Jeśli chodzi o sposób ochrony Twoich danych, zapoznaj się z <a href=\"https://www.adyen.com/policies-and-disclaimer/privacy-policy\">https://www.adyen.com/policies-and-disclaimer/privacy-policy</a>.",
    "paypalTips": "Usługę płatności zapewnia PayPal. Jeśli chodzi o sposób ochrony Twoich danych, zapoznaj się z <a href=\"https://www.paypal.com/c2/webapps/mpp/ua/privacy-full\">https://www.paypal.com/c2 /webapps/mpp/ua/privacy-full</a>",
    "switchCountryTips": "Twój preferowany kraj/region to ${servercountry}. Czy chcesz zmienić kraj i walutę?",
    "paypalBtn": "Zapłać teraz kartą",
    "paypalOr": "lub",
    "paypalCard1": "Imię i nazwisko posiadacza karty (opcjonalnie)",
    "paypalCard2": "Numer karty",
    "checkUserID": "Połącz",
    "success": "SUKCES",
    "changeCurrencyContent": "Czy chcesz zmienić region i walutę, aby dopasować je do ustawień w grze: ${servercountry}？",
    "productDescription": "Farmerska Kasa to równowartość gotówki, za którą można kupić dowolne pakiety i oferty w grze.",
    "payButton": "ZAPŁAĆ",
    "userIdNotice": "Najpierw wprowadź swoją nazwę użytkownika, aby połączyć swoje konto gry",
    "account": "Konto",
    "card": "Karta",
    "notification": "Wprowadź swoją nazwę użytkownika, aby połączyć swoje konto, wybierz żądane produkty, a następnie zapłać preferowaną metodą płatności. Po ponownym załadowaniu gry zakupione przedmioty pojawią się na Twoim koncie i będą gotowe do użycia.\r\n\r\nJeśli masz jakiekolwiek pytania, skontaktuj się z obsługą klienta w grze.",
    "rongluRank": "Poziom Pieca:",
    "tips": "Jak używać?",
    "checkTIps1": "Przeczytałem i akceptuję <a :href=\"policyUrl\">„Politykę prywatności”</a>, <a :href=\"serviceURl\">„Warunki korzystania z usługi”</a> i <a :href=\"paymentURl\">„Warunki płatności”</a>.",
    "checkTIps2": "Przeczytaj i zaznacz pole wyboru",
    "selectTips": "(Wybrana zostanie waluta ostatniego zakupu w grze)",
    "koPayTips": "Jeśli walutą obcą na Twojej karcie bankowej jest won koreański, zostanie użyta usługa dynamicznego przeliczania walut (DCC), a dodatkowa opłata manipulacyjna może zostać naliczona przez zewnętrzny serwer proxy, a nie przez tę witrynę.",
    "PayTips": ""
  },
  "invoice": {
    "title": "Faktura",
    "transactionId": "ID Transakcji",
    "transactionDate": "Data Transakcji",
    "totalAmount": "Cena całkowita",
    "paymentMethod": "Metoda płatności",
    "description": "Opis",
    "game": "Gra",
    "quantity": "Ilość",
    "price": "Cena",
    "amount": "Cena",
    "total": "W sumie",
    "footTitle": "Uwagi",
    "footContent": "Dziękujemy za wspieranie Century Games!",
    "button1": "Odbierz fakturę",
    "button2": "Powrót bez paragonu",
    "giveupInvoice": "Nie otrzymasz paragonu za zamówienie. Potwierdzasz?"
  },
  "payment": {
    "card": "Karta kredytowa/karta debetowa",
    "paypal": "PayPal"
  },
  "country": {
    "countryTitle1": "KRAJ/REGION",
    "Africa": "Afryka",
    "America": "Ameryka",
    "Asia": "Azja",
    "Europe": "Europa",
    "Oceania": "Oceania",
    "ZA": "Afryka Południowa",
    "US": "Stany Zjednoczone",
    "HK": "Hongkong, Chiny",
    "JP": "Japonia",
    "KR": "Korea",
    "SG": "Singapur",
    "SA": "Arabia Saudyjska",
    "IQ": "Irak",
    "TW": "Tajwan, Chiny",
    "TH": "Tajlandia",
    "GB": "Wielka Brytania",
    "AU": "Australia",
    "countryLanguage1": "JĘZYK",
    "AE": "Zjednoczone Emiraty Arabskie",
    "DE": "Niemcy",
    "PT": "Portugalia",
    "RU": "Rosja",
    "ES": "Hiszpania",
    "CH": "Szwajcaria",
    "TR": "Turcja",
    "KW": "Kuwejt",
    "QA": "Katar",
    "PL": "Polska",
    "ID": "Indonezja",
    "IT": "Włochy",
    "IN": "Indie",
    "FR": "Francja",
    "CA": "Kanada",
    "NL": "Holandia",
    "AT": "Austria",
    "RS": "Serbia",
    "SE": "Szwecja",
    "MY": "Malezja",
    "BE": "Belgia",
    "DK": "Dania",
    "FI": "Finlandia",
    "PH": "Filipiny",
    "NO": "Norwegia",
    "BR": "Brazylia",
    "NZ": "Nowa Zelandia",
    "UA": "Ukraina",
    "RO": "Rumunia"
  },
  "extra_info": {
    "kingdom": "Państwo: #"
  },
  "adyen": {
    "note": "Usługę płatniczą świadczy firma Adyen, oferująca bezpieczne transakcje i posiadająca najwyższy poziom certyfikacji PCI-DSS od międzynarodowych organizacji obsługujących karty kredytowe, obsługująca płatności kartami krajowymi i zagranicznymi.",
    "note2": "Uwaga: Zaznacz \"Zapisz na potrzeby następnej płatności\", aby zapisać dane swojej karty płatniczej w bieżącej przeglądarce na potrzeby przyszłych płatności."
  },
  "pay": {
    "error1": "Jeśli coś poszło nie tak, spróbuj ponownie później lub użyj innej metody płatności. Skontaktuj się z obsługą klienta, jeśli masz więcej pytań."
  },
  "meta": {
    "title": "Sklep Wiejskie Życie Przygoda",
    "description": "Sklep Wiejskie Życie Przygoda jest oficjalnym sklepem Wiejskie Życie Przygoda, oferującym graczom kanał doładowań po obniżonych cenach oraz pakiety do gry.",
    "keywords": "farma, uprawa, rynek, ulepszenie, eksploracja, mapa, postać, poziom, symulacja, strategia, zapłata, sklep, doładowanie, płatność"
  }
};


// WEBPACK FOOTER //
// ./src/lang/PL.js